import * as Sentry from '@sentry/react';
import { FAILED_FETCH_DYNAMICALLY_IMPORT_MODULE } from '@/consts/error-messages';

Sentry.init({
  beforeSend(event, hint) {
    const error = hint.originalException;
    if (
      error instanceof Error &&
      error.message.includes(FAILED_FETCH_DYNAMICALLY_IMPORT_MODULE)
    ) {
      return null;
    }
    return event;
  },
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [import.meta.env.VITE_API_ENDPOINT],
      networkRequestHeaders: ['X-Custom-Header'],
      networkResponseHeaders: ['X-Custom-Header'],
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    ...(import.meta.env.DEV ? ['localhost'] : []),
    /^https:\/\/.*\.southmax\.com/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
  // TODO: when doamin check add api url
  allowUrls: [],
  environment: import.meta.env.MODE,
});

export { Sentry };
